export function cleanMarkdownCitations(text) {
    // Normalize non-string payloads to avoid render-time issues.
    const value = typeof text === "string" ? text : String(text ?? "");
    // ลบ citation แบบ [1], [2], [3]
    return value.replace(/\[\d+\]/g, "");
}